import React, { useState } from 'react';
import { FaUtensils, FaInfoCircle, FaClock } from 'react-icons/fa';
import PageChrome from '../../components/layout/PageChrome';
import KosherSoupForm from '../../components/forms/KosherSoupForm';
import kosher from '../../cms/kosher.json';
import '../../css/student-life/KosherSoupDelivery.css';

const soupDeliveryDetails = kosher;

const KosherSoupDelivery = () => {
  const [showForm, setShowForm] = useState(false);

  const handleRequestSoup = () => {
    setShowForm(true);
  };

  const closeForm = () => {
    setShowForm(false);
  };

  return (
    <>
      <PageChrome title={kosher.title} subtitle={kosher.subtitle} intro={kosher.intro}>
        <section className="kosher-soup-delivery-section">
          <div className="kosher-soup-delivery-grid">
            {/* Availability Card */}
            <div className="kosher-soup-delivery-card">
              <div className="kosher-soup-delivery-card-title">
                  <FaClock /> Availability
              </div>
              <div className="kosher-soup-delivery-card-content">
                <div className="kosher-soup-delivery-list">
                  <div className="kosher-soup-delivery-list-item">
                    <strong>Days:</strong> {soupDeliveryDetails.availability.days}
                  </div>
                  <div className="kosher-soup-delivery-list-item">
                    <strong>Hours:</strong> {soupDeliveryDetails.availability.hours}
                  </div>
                  <div className="kosher-soup-delivery-list-item">
                    <strong>Season:</strong> {soupDeliveryDetails.availability.season}
                  </div>
                  </div>
                </div>
              </div>

            {/* Restrictions Card */}
            <div className="kosher-soup-delivery-card">
              <div className="kosher-soup-delivery-card-title">
                <FaInfoCircle /> Restrictions
              </div>
              <div className="kosher-soup-delivery-card-content">
                <ul className="kosher-soup-delivery-list">
                  {soupDeliveryDetails.restrictions.map((restriction, index) => (
                    <li key={index} className="kosher-soup-delivery-list-item">
                      {restriction}
                    </li>
                  ))}
                </ul>
              </div>
              </div>

            {/* Delivery Info Card */}
            <div className="kosher-soup-delivery-card">
              <div className="kosher-soup-delivery-card-title">
                <FaUtensils /> Delivery Information
              </div>
              <div className="kosher-soup-delivery-card-content">
                <ul className="kosher-soup-delivery-list">
                  {soupDeliveryDetails.deliveryInfo.map((info, index) => (
                    <li key={index} className="kosher-soup-delivery-list-item">
                      {info}
                    </li>
                  ))}
                </ul>
              </div>
              </div>
            </div>

          <div className="kosher-soup-delivery-cta">
              <button
              className="kosher-soup-delivery-request-button"
              onClick={handleRequestSoup}
              >
              {kosher.requestButtonText}
              </button>
          </div>
        </section>
      </PageChrome>

      {showForm && <KosherSoupForm onClose={closeForm} />}
    </>
  );
};

export default KosherSoupDelivery; 